module.exports = __webpack_public_path__ + "img/icon-logout-red.3237674d.svg";